import {useMutation, gql} from '@apollo/client'

export const MUTATE_DELETE_SAVED_LIST = gql`
  mutation MUTATE_DELETE_SAVED_LIST($listName: String!, $azureRole: String) {
    deleteList(listName: $listName, azureRole: $azureRole) {
      success
    }
  }
`

export function useDeleteSavedList() {
  return useMutation(MUTATE_DELETE_SAVED_LIST, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
